import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DialogFormularioPesquisaComponent} from './dialog-formulario-pesquisa.component';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';



@NgModule({
  declarations: [
    DialogFormularioPesquisaComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule
  ],
  entryComponents: [DialogFormularioPesquisaComponent]
})
export class DialogFormularioPesquisaModule { }
